import { type ReactNode, type ReactElement } from 'react';
import cn from 'classnames';

import styles from './tile.module.scss';

interface ITileTabsRowProps {
  children: ReactNode,
  dataTest: string,
  overlap?: boolean,
}

const TileTabsRow = ({ children, dataTest, overlap = true }: ITileTabsRowProps): ReactElement => (
  <>
    <div className={ cn(styles.tabsRow, { [styles.tabsRowNoMargin]: !overlap }) } data-test={ dataTest }>
      { children }
    </div>
    <div className={ styles.tabsRowBorder } />
  </>
);

export { TileTabsRow };
export type { ITileTabsRowProps };
